/**
 * @file index.tsx
 *
 * @fileoverview Renders a a facet category block to show on desktop.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { FacetBlockCategoryParagraph } from '~/jobiqo/types/types';
import { LinksBlock } from '~/vcl/molecules/04-navigation/03-links-block';
import { getFacetLinks } from '../../utils/getFacetLinks';

interface FacetCategoryProps {
  /**
   * The facet category, includes the title and the facets themselves.
   */
  category: FacetBlockCategoryParagraph;
}
export default function FacetCategory({ category }: FacetCategoryProps) {
  const intl = useIntl();
  return (
    <LinksBlock
      title={category.title as string}
      maxItems={category.maxItems as number}
      links={getFacetLinks(category)}
      expandText={intl.formatMessage({
        id: 'facet_block_expand',
        defaultMessage: 'more',
      })}
      collapseText={intl.formatMessage({
        id: 'facet_block_collapse',
        defaultMessage: 'less',
      })}
    />
  );
}
